import React, { useState, useEffect } from "react";
import { usePassword } from "../context/PasswordContext";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import * as styles from "../pages/styles.module.scss";
import Core20 from "../images/core20.svg";

const AuthWrapper = ({ children }) => {
  const { isAuthenticated, login } = usePassword();
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleLogin = async () => {
    try {
      await login(password);
      setPassword("");
      setError("");
    } catch (err) {
      setError("Incorrect password.");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  if (!isHydrated) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <div className={styles.passwordOverlay}>
        <div className={styles.passwordPrompt}>
          <h1 className={styles.title}>Welcome to </h1>
          <Core20 className={styles.coreImg} />
          <h3 className={styles.sub}>legacy product</h3>
          <div className={styles.inputWrapper}>
            <input
              type={isPasswordVisible ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Enter password"
            />
            <button
              className={styles.showhidepsw}
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            >
              {isPasswordVisible ? <AiFillEye /> : <AiFillEyeInvisible />}
            </button>
          </div>
          {error && <p className={styles.errorMessage}>{error}</p>}
          <button
            className={styles.submitPassword}
            onClick={handleLogin}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthWrapper;
